// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const vehicleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVehicles: builder.query({
      query: ({ limit, page, search }) =>
        `/api/v1/admin/vehicle/listing?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`,
    }),

    deleteVehicleData: builder.mutation({
      query: () => ({
        url: "/api/v1/admin/vehicle/remove",
        method: "DELETE",
      }),
    }),
  }),
});

export const { useGetVehiclesQuery, useDeleteVehicleDataMutation } =
  vehicleApiSlice;
